import { useEffect, useState } from 'react';
import '@/App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import CreativeShowcase from './components/CreativeShowcase';
import Services from './components/Services';
import Pricing from './components/Pricing';
import FreeVideoOffer from './components/FreeVideoOffer';
import Blog from './components/Blog';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Chatbot from './components/Chatbot';

function App() {
  const [showNewsletter, setShowNewsletter] = useState(false);

  useEffect(() => {
    // Smooth scroll polyfill for older browsers
    document.documentElement.style.scrollBehavior = 'smooth';

    // Show newsletter popup after 5 seconds if not dismissed before
    const hasSeenPopup = localStorage.getItem('orian_newsletter_seen');
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setShowNewsletter(true);
        localStorage.setItem('orian_newsletter_seen', 'true');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="App min-h-screen bg-black">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#111',
            color: '#fff',
            border: '1px solid #333',
          },
        }}
      />
      <Header />
      <main>
        <Hero />
        <About />
        <CreativeShowcase />
        <Services />
        <Pricing />
        <FreeVideoOffer />
        <Blog />
        <Team />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <Chatbot />
    </div>
  );
}

export default App;
